<header class="navbar navbar-fixed-top bg-system">
    <div class="navbar-logo-wrapper">
        <a class="navbar-logo-text" href="/" ng-click="mainPage()">
            <img src="img/logo-blue.svg" alt="Hodxpress.com">
        </a>
    </div>

    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/projeler">
                <strong class="p10 fs18">Ofis İşleri</strong>
            </a>
        </li>
    </ul>
    <ul class="nav navbar-nav navbar-right intercom">
        <li class="hidden-xs">
            <a href="#" class="navbar-fullscreen fs18 toggle-active" ng-click="intercom()">
                <img src="/img/Destek.png" alt="" width="24px">
            </a>
        </li>
    </ul>
</header>
  
<header class="navbar navbar-fixed-top subnavbar bg-system" ng-show="isActive('projeler')">

    <ul class="nav navbar-nav navbar-left">
        <input 
            type="text" 
            ng-model="project_name" 
            ng-change="findProject(project_name)"
            class="btn btn-operation ml10 text-input" 
            placeholder="Projelerde Ara" >
    </ul>
    
    <ul class="nav navbar-nav navbar-right">
    
        <li class="hidden-xs">
            <a href="#" class="navbar-fullscreen  btn btn-warning btn-rounded" data-toggle="modal" data-target="#newProject" ng-click="newProject()">
                <i class="fa fa-plus"></i> Proje Ekle
            </a>
        </li>

        <a href="#" class="btn btn-operation ml10" ng-click="refreshData('projects')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

    </ul>
    
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="!isActive('projeler')">
        
    <ul class="nav navbar-nav navbar-left">

        <input 
            type="text" 
            ng-model="filterData.id" 
            class="btn btn-operation ml10 text-input" 
            placeholder="Kelime ile Ara" >

        <input 
            type="text" 
            options="opts" 
            date-range-picker 
            ng-model="filterData.scheduled_time" 
            class="btn btn-operation ml10" 
            placeholder="Kargo Tarihi" >
        
        <select class="ml10 selectpicker" 
            multiple 
            title="Personel"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.workers"
            data-style="btn-primary">
            <option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
        </select>

        <select class="ml10 selectpicker" 
            multiple 
            title="Önem Derecesi"
            data-live-search="true" 
            data-selected-text-format="count" 
            data-language="tr_TR"
            ng-model="filterData.importance"
            data-style="btn-primary">
            <option ng-repeat="member in data.importance" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.name}}</option>
        </select>

                
        <a href="#" class="btn btn-operation ml10" ng-click="refreshData('tasks')" style="line-height: 20px;">
            <i class="fa fa-refresh"></i>
        </a>

    </ul>

    <ul class="nav navbar-nav navbar-right">

        <li class="hidden-xs">
            <a href="#" class="navbar-fullscreen btn btn-warning btn-rounded" <a href="#" ng-click="newTaskStep()">
                <i class="fa fa-plus fs16"></i> KargoAdımı Ekle
            </a>
        </li>
    
        <li class="hidden-xs">
            <a href="#" class="navbar-fullscreen btn btn-rounded" <a href="#" ng-click="getActivities()">
                <i class="fa fa-bars fs16"></i> Hareketler
            </a>
        </li>

    </ul>
    
</header>
